// extracted by mini-css-extract-plugin
export default {"iconContainer":"InBasketIcon_iconContainer__B2FTL","icon":"InBasketIcon_icon__TAGJv"};